// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_co-0";